'use strict';

define('RaceInfo',[
    'RaceInfoFac',
    'RaceUrlFac',
    'RaceLinkFilter',
    'RaceMtpStatusFac'
], function (RaceInfoFac, RaceUrlFac, RaceLinkFilter, RaceMtpStatusFac) {

    return angular
        .module('TVG.RaceInfo', [])
        .factory('RaceInfoFac', RaceInfoFac)
        .factory('RaceUrlFac', RaceUrlFac)
        .factory('RaceMtpStatusFac', RaceMtpStatusFac)
        .filter('raceLink', RaceLinkFilter)
        .constant('racePerformances', [
            {perfAbbr:'Adv', fullPerf:'Advance'},
            {perfAbbr:'Day', fullPerf:'Day'},
            {perfAbbr:'Eve', fullPerf:'Evening'},
            {perfAbbr:'Fut', fullPerf:'Future'},
            {perfAbbr:'Mat', fullPerf:'Matinee'},
            {perfAbbr:'Ngt', fullPerf:'Night'},
            {perfAbbr:'Twi', fullPerf:'Twilight'}
        ])
        .name;
    }
);

